import { Component, OnInit, Input, Injector, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicAggregateGUI } from "src/model/class/component classes/generic-basic-aggregate-gui";
import { CustomInterfacePlaceholderDirective } from "src/directive/custom-interface-placeholder.directive";

@Component({
    selector: "app-two-rows-template",
    templateUrl: "./multiple-rows-template.component.html",
    styleUrls: ["./multiple-rows-template.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultipleRowsTemplateComponent
  extends GenericBasicAggregateGUI
  implements OnInit
{
  @ViewChild(CustomInterfacePlaceholderDirective, { static: true })
  componentHost: CustomInterfacePlaceholderDirective;

  constructor(_injector: Injector) {
    super(_injector);
  }

  async ngOnInit() {
    this.searchLabelNameComponent();
  }

  ngAfterContentInit() {
    this.componentHost.drawCustomInterfaceComponents(
      this.aggregate.listComponent,
      false,
      this.hAlign.CENTER,
      false
    );
  }
}
